<template>
  <Globe>
    <Overlay />
  </Globe>
</template>

<script>
import Globe from '../../globe/Globe.vue';
import Overlay from '../../Overlay.vue';

export default {
  name: 'Home',
  components: {
    Globe,
    Overlay,
  },
};
</script>

<style>
body {
  font-size: 1.1em;
}

a:link,
a:visited,
a:active {
  color: #6382a0;
}

a:hover {
  color: white;
  text-decoration: underline;
}
</style>
